'use strict';

module.exports = [
    '$uibModalInstance',
    '$window',
    '$scope',
    '$timeout',
    'modalElement',
    'modalGraphKind',
    'modalUpdateFilters',
    'modalGraphId',
    function ($uibModalInstance, $window, $scope, $timeout, modalElement, modalGraphKind, modalUpdateFilters, modalGraphId) {
        var _this = this;

        _this.element = modalElement;
        _this.graphKind = modalGraphKind;
        _this.graphId = modalGraphId;
        _this.domSuffix = '-max';
        _this.layoutViewport = { width: 0, height: 0 };
        _this.layoutReady = false;

        _this.close = function () {
            $uibModalInstance.dismiss('close');
        };

        _this.updateFilters = function () {
            if (modalUpdateFilters) {
                modalUpdateFilters();
            }
        };

        const measure = function () {
            const el = document.querySelector('.graph-maximize-modal__body');
            if (!el || el.clientWidth < 1 || el.clientHeight < 1) {
                return;
            }
            const w = el.clientWidth;
            const h = el.clientHeight;
            _this.layoutViewport.width = w;
            _this.layoutViewport.height = h;
            _this.layoutReady = true;
        };

        const onResize = function () {
            measure();
            if (!$scope.$$phase && !$scope.$root.$$phase) {
                $scope.$apply();
            }
        };

        angular.element($window).on('resize.graphMaximize', onResize);

        $scope.$on('$destroy', function () {
            angular.element($window).off('resize.graphMaximize', onResize);
        });

        $timeout(function () {
            measure();
            $timeout(measure, 50);
            $timeout(measure, 200);
        }, 0);
    },
];
